import React, { useState } from 'react';
import Topbar from './Topbar';
import Sidebar from './Sidebar';
import SubTabBar from './SubTabBar';
import BreadcrumbBar from './BreadcrumbBar';
import KpiRow from './KpiRow';
import KiPanel from './KiPanel';
import SettingsPanel from './SettingsPanel';

export default function PageLayout({ domain = 'ops', title = '', kpis = [], sidebarItems = [], topbarKpis = [], activePath = '', activeSearch = '', subTabs = [], breadcrumbs = [], onBack, onNavigate, onSearch, masterUrl = '/', children }) {
  const [kiOpen, setKiOpen] = useState(false);
  const [settingsOpen, setSettingsOpen] = useState(false);
  const [sidebarOpen, setSidebarOpen] = useState(false);

  // Inject onClick into sidebar items for SPA navigation
  const itemsWithNav = onNavigate
    ? sidebarItems.map(section => ({
        ...section,
        children: section.children?.map(item => ({
          ...item,
          onClick: onNavigate,
        })),
      }))
    : sidebarItems;

  const openKi = () => { setKiOpen(true); };

  return (
    <div style={{
      height: '100vh',
      display: 'flex',
      flexDirection: 'column',
      overflow: 'hidden',
      '--accent': `var(--accent-${domain})`,
    }}>
      {/* Topbar */}
      <Topbar
        domain={domain}
        domainLabel={title || domain.toUpperCase()}
        kpis={topbarKpis}
        onSearch={onSearch}
        kiOpen={kiOpen}
        onKiToggle={() => setKiOpen(!kiOpen)}
        onSettingsOpen={() => setSettingsOpen(true)}
        onMenuToggle={() => setSidebarOpen(!sidebarOpen)}
      />

      {/* Body */}
      <div style={{ flex: 1, display: 'flex', overflow: 'hidden' }}>
        {/* Sidebar */}
        <Sidebar
          items={itemsWithNav}
          activePath={activePath}
          domain={domain}
          masterUrl={masterUrl}
          onOpenKi={openKi}
          mobileOpen={sidebarOpen}
          onMobileClose={() => setSidebarOpen(false)}
        />

        {/* Main Content */}
        <main className="eco-main">
          {subTabs.length > 0 && (
            <SubTabBar
              tabs={subTabs}
              accent={`var(--accent-${domain})`}
              activePath={activePath}
              activeSearch={activeSearch}
              onNavigate={onNavigate}
            />
          )}
          {breadcrumbs.length > 0 && (
            <BreadcrumbBar items={breadcrumbs} onBack={onBack} accent={`var(--accent-${domain})`} />
          )}
          <div style={{ padding: 'var(--gap-md)', display: 'flex', flexDirection: 'column', gap: 'var(--gap-md)', flex: 1 }}>
            {kpis.length > 0 && <KpiRow kpis={kpis} />}
            {children}
          </div>
        </main>

        {/* KI Panel */}
        <KiPanel
          domain={domain}
          visible={kiOpen}
          onClose={() => setKiOpen(false)}
        />
      </div>

      {/* Statusbar */}
      <footer className="eco-statusbar hide-mobile">
        <span>devbox-ecosystem / {domain}</span>
        <span>{new Date().toLocaleDateString('de-DE')}</span>
      </footer>

      {/* Settings Modal */}
      <SettingsPanel domain={domain} visible={settingsOpen} onClose={() => setSettingsOpen(false)} />
    </div>
  );
}
